var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.generateList()),function(width,key){return _c('v-skeleton-loader',{key:(key + "-" + width),attrs:{"type":"text","width":width}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }